import { FiltersState } from './state';

// @TODO Remove this after Refactor filter components to read atom state directly.
export const filtersToFilterInValues = <T extends Record<string, unknown>>(
  filter: FiltersState<T>,
): string[] => {
  const values = Object.values(filter.in) as (string[] | undefined)[];
  return values.reduce<string[]>(
    (acc, value) => (value ? [...acc, ...value] : acc),
    [],
  );
};
